/**============================================================
*   [Class] Service：事例スライダー
============================================================*/
export default class ServiceCaseSlider {
  constructor(
    target,
    key,
    targetClass
  )
  {
    //main slide
    this.swiperSlide = document.querySelector(`${targetClass} .p-service-case__slider-main`);
    this.swiperSlideItem = document.querySelectorAll(`${targetClass} .p-service-case__slider-main .swiper-slide`);
    this.swiperSlideItemNum = this.swiperSlideItem.length * 3;

    //thumb slide
    this.swiperThumbSlide = document.querySelector(`${targetClass} .p-service-case__slider-thumb`);
    this.swiperThumbSlideItem = document.querySelectorAll(`${targetClass} .p-service-case__slider-thumb .swiper-slide`);

    //サムネイルの左側が欠けてしまうので枚数増やす
    if(this.swiperSlideItem.length <= 4) {
      this.swiperSlideItem.forEach((item)=>{
        let clone = item.cloneNode(true);
        document.querySelector(`${targetClass} .p-service-case__slider-main .swiper-wrapper`).appendChild(clone);
      })
      this.swiperThumbSlideItem.forEach((item)=>{
        let cloneThumb = item.cloneNode(true);
        document.querySelector(`${targetClass} .p-service-case__slider-thumb .swiper-wrapper`).appendChild(cloneThumb);
      })
    }

    this.swiperKey = key;
    this.swiperSlide.classList.remove('swiper-disabled');
    this.swiperSlide.classList.add('swiper-'+ this.swiperKey);

    //サムネイルスライド
    const swiperThumbnail = new Swiper(this.swiperThumbSlide, {
      loop: true,
      slidesPerView: 1,
      freeMode: true,
      watchSlidesProgress: true,//スライダーの動きにスライドを追従させる
      loopAdditionalSlides: this.swiperSlideItemNum,
      loopPreventsSlide: true,
      loopedSlides: 0,
      speed: 2000,
      followFinger: false,
      grabCursor: false,
      slidesPerGroup: 1,
      loopFillGroupWithBlank: true,
    });

    //メインスライド
    new Swiper(this.swiperSlide, {
      slidesPerView: 1,
      loop: true,
      loopAdditionalSlides: this.swiperSlideItemNum,
      loopPreventsSlide: true,
      loopedSlides: 0,
      followFinger: false,
      grabCursor: false,
      speed: 2000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      observer: true,
      observeParents: true,
      thumbs: {
        swiper: swiperThumbnail, //連動したいスライダー（swiperThumbnailを指定する）
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
    });
  }
}
